module.exports = {
  instagram: 'https://www.instagram.com/traveleasy_manager',
  kakao: 'https://pf.kakao.com/_MtSfK/chat',
  smartstore: 'https://smartstore.naver.com/traveleasy_jeju',
  blog: 'https://blog.naver.com/dreamco101',
};
